"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformGetInfoPreferencesV2ResponseApiDtoToDomain = exports.transformGetInfoPreferencesV2ResponseDataApiDomainToDto = void 0;
const class_transformer_1 = require("class-transformer");
const get_info_preferences_v2_api_domain_1 = require("../get-info-preferences-v2-api-domain");
// =============================================================================
// Response
// =============================================================================
function transformGetInfoPreferencesV2ResponseDataApiDomainToDto(domain) {
    return (0, class_transformer_1.instanceToPlain)(domain);
}
exports.transformGetInfoPreferencesV2ResponseDataApiDomainToDto = transformGetInfoPreferencesV2ResponseDataApiDomainToDto;
function transformGetInfoPreferencesV2ResponseApiDtoToDomain(dto) {
    return (0, class_transformer_1.plainToInstance)(get_info_preferences_v2_api_domain_1.GetInfoPreferencesV2ResponseApiDomain, dto);
}
exports.transformGetInfoPreferencesV2ResponseApiDtoToDomain = transformGetInfoPreferencesV2ResponseApiDtoToDomain;
//# sourceMappingURL=index.js.map